import ko from "knockout";
import { CustomError, customFetch as fetch } from "../../../fetch";

export default class FinanceInfo {
    parent: any;
    saving: KnockoutObservable<boolean>;
    validationErrors: KnockoutObservableArray<CustomError>;
    shouldDisableFields: KnockoutObservable<boolean>;
    
    bankAccountNumber: KnockoutObservable<string>;
    gAccountNumber: KnockoutObservable<string>;
    paymentTerm: KnockoutObservable<string>;
    directDebit: KnockoutObservable<string>;
    billingEmail: KnockoutObservable<string>;

    invoiceLayout: KnockoutObservable<string>;

    employeeWithoutPensionFee: KnockoutObservable<number>;
    employeeWithoutPensionFeeAnalysis: KnockoutObservable<number>;
    employeeWithPensionFee: KnockoutObservable<number>;
    employeeWithPensionFeeAnalysis: KnockoutObservable<number>;
    employeeUnderTwentyOnePensionFee: KnockoutObservable<number>;
    employeeUnderTwentyOnePensionFeeAnalysis: KnockoutObservable<number>;
    employeeAboveTwentyOnePensionFee: KnockoutObservable<number>;
    employeeAboveTwentyOnePensionFeeAnalysis: KnockoutObservable<number>;
    
    constructor(model: any, parent: any) {
        this.parent = parent;
        this.saving = ko.observable<boolean>(false);
        this.validationErrors = ko.observableArray<CustomError>();
        this.shouldDisableFields = ko.pureComputed(() => this.parent.onboardingStatus() !== 1);
        
        this.bankAccountNumber = ko.observable(model?.bank_account_number || "").extend({
            errorHandler: { source: this.validationErrors, id: 'BankAccountNumber' }
        });
        this.gAccountNumber = ko.observable(model?.g_account_number || "").extend({
            errorHandler: { source: this.validationErrors, id: 'GAccountNumber' }
        });
        this.paymentTerm = ko.observable(model?.payment_term || "").extend({
            errorHandler: { source: this.validationErrors, id: 'PaymentTerm' }
        });
        this.directDebit = ko.observable(model?.direct_debit || "").extend({
            errorHandler: { source: this.validationErrors, id: 'DirectDebit' }
        });
        this.billingEmail = ko.observable(model?.billing_email || "").extend({
            errorHandler: { source: this.validationErrors, id: 'BillingEmail' }
        });
        this.invoiceLayout = ko.observable(model?.invoice_layout || "").extend({
            errorHandler: { source: this.validationErrors, id: 'InvoiceLayout' }
        });

        this.employeeWithoutPensionFee = ko.observable(model?.employee_without_pension_fee || "").extend({
            errorHandler: { source: this.validationErrors, id: 'EmployeeWithoutPensionFee' }
        });
        this.employeeWithoutPensionFeeAnalysis = ko.observable(model?.employee_without_pension_fee_analysis || "").extend({
            errorHandler: { source: this.validationErrors, id: 'EmployeeWithoutPensionFeeAnalysis' }
        });

        this.employeeWithPensionFee = ko.observable(model?.employee_with_pension_fee || "").extend({
            errorHandler: { source: this.validationErrors, id: 'EmployeeWithPensionFee' }
        });
        this.employeeWithPensionFeeAnalysis = ko.observable(model?.employee_with_pension_fee_analysis || "").extend({
            errorHandler: { source: this.validationErrors, id: 'EmployeeWithPensionFeeAnalysis' }
        });

        this.employeeUnderTwentyOnePensionFee = ko.observable(model?.employee_under_twentyone_pension_fee || "").extend({
            errorHandler: { source: this.validationErrors, id: 'EmployeeUnderTwentyOnePensionFee' }
        });
        this.employeeUnderTwentyOnePensionFeeAnalysis = ko.observable(model?.employee_under_twentyone_pension_fee_analysis || "").extend({
            errorHandler: { source: this.validationErrors, id: 'EmployeeUnderTwentyOnePensionFeeAnalysis' }
        });

        this.employeeAboveTwentyOnePensionFee = ko.observable(model?.employee_above_twentyone_pension_fee || "").extend({
            errorHandler: { source: this.validationErrors, id: 'EmployeeAboveTwentyOnePensionFee' }
        });
        this.employeeAboveTwentyOnePensionFeeAnalysis = ko.observable(model?.employee_above_twentyone_pension_fee_analysis || "").extend({
            errorHandler: { source: this.validationErrors, id: 'EmployeeAboveTwentyOnePensionFeeAnalysis' }
        });
    }

    toJson() {
        return {
            bank_account_number: this.bankAccountNumber(),
            g_account_number: this.gAccountNumber(),
            invoice_layout: this.invoiceLayout(),
            payment_term: this.paymentTerm(),
            direct_debit: this.directDebit(),
            billing_email: this.billingEmail(),
            employee_without_pension_fee: this.employeeWithoutPensionFee(),
            employee_without_pension_fee_analysis: this.employeeWithoutPensionFeeAnalysis(),
            employee_with_pension_fee: this.employeeWithPensionFee(),
            employee_with_pension_fee_analysis: this.employeeWithPensionFeeAnalysis(),
            employee_under_twentyone_pension_fee: this.employeeUnderTwentyOnePensionFee(),
            employee_under_twentyone_pension_fee_analysis: this.employeeUnderTwentyOnePensionFeeAnalysis(),
            employee_above_twentyone_pension_fee: this.employeeAboveTwentyOnePensionFee(),
            employee_above_twentyone_pension_fee_analysis: this.employeeAboveTwentyOnePensionFeeAnalysis(),
        };
    }

    async submit() {
        this.saving(true);
        this.parent.submit();
        this.saving(false);
    }

    async validateModel() {
        const url = '/admin/CompanyOnboarding/ValidateFinanceInfoModel';

        const body= this.toJson();

        const response = await fetch(url, {
            headers: {
                'Content-type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            this.parent.validationIsSuccessful = false;
            if (response.errors && response.errors.length > 0) {
                this.validationErrors(response.errors);
            }
        }
    }
}
